<div class="text-center mb-4">
  <a target="_blank" *ngIf="!!data.src" [href]="data.src">
    <span class="file-icon"><i class={{data.iconClass}}></i></span>
    <span class="d-block w-100">{{data.filename}}.{{data.extension}}</span>
  </a>
</div>
